const HEIGHT_MAP: Record<string, string> = {
  xs: 'h-4',
  sm: 'h-8',
  md: 'h-16',
  lg: 'h-24',
  xl: 'h-40',
};

export function SpacerBlock({ props }: { props: { height?: string } }) {
  const cls = HEIGHT_MAP[props.height ?? 'md'] ?? 'h-16';
  return <div className={cls} aria-hidden="true" />;
}
